import { BaseApi } from '@smorder/logic';
import { parse } from '../utils/parseQuery';

class SignageApi extends BaseApi {
  * loadOrdersForSignage(locationId) {

    const queryParams = parse(window.location.search);

    let params = window.location.search.includes('debug') ? `?daysLookBack=200&t=${new Date().getTime()}` : '';

    if (queryParams.cashboxId) {
      if (params) {
        params += '&';
      } else {
        params += '?';
      }

      params += `cashboxId=${queryParams.cashboxId}`;
    }

    return yield this.apiFetch(`/api/v1/location/${locationId}/OrdersForSignage${params}`, {
      method: 'GET',
    });
  }

  * loadLocation(locationId) {
    return yield this.apiFetch(`/api/v1/locations/${locationId}`, {
      method: 'GET',
    });
  }
}

export default SignageApi;
